import axios from 'axios';
import axiosInstance from './commonAPI';
import { optimizeProductImage } from '../utils/optimizeProductImage';

export const uploadProductImage = async (file: File) => {
    const optimized = await optimizeProductImage(file);
    const { data } = await axiosInstance.post('/api/photos/presigned-url', { originalFileName: optimized.name });
    await axios.put(data.presignedUrl, optimized, { headers: { 'Content-Type': optimized.type } });
    return { originalFileName: file.name, storedFileName: data.storedFileName as string };
};
